import { apiGetConfirmEmail } from '@/modules/Claim/services/pdf'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { WARRANTY_MODULE_NAME } from '@/store/types'
import { FLOW_MODULE_NAME } from '@/modules/Flow/store/types'
import maActionsButtons from '@/components/button-blue'
import { mapState } from 'vuex'
import { prepareErrorForSentry } from '@/utils/errorHandling'

export default {
  name: 'claimClosing',

  mixins: [flowMixin],
  data() {
    return {
      loading: false,
      address: null,
      renInfo: {}
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyWarranties: 'warranties',
      stateRepDeclaration: 'repDeclaration',
      stateWarrantyAddress: 'address',
      stateWarrantySinisterSummary: 'sinisterSummary'
    }),
    ...mapState(FLOW_MODULE_NAME, {
      stateFlowState: 'flowState',
      stateFlowViewOptions: 'flowViewOptions'
    }),
    ...mapState(['date']),

    e2eFlowName() {
      return this.getE2EFlow
    },
    isInmobilier() {
      try {
        return (
          this.stateWarrantyWarranties.hasOwnProperty('immobilier') ||
          this.stateWarrantyWarranties.hasOwnProperty('embellishments') ||
          this.stateFlowViewOptions.smart_values.inmobilier
            .compensation_base !== 0
        )
      } catch {
        return false
      }
    },
    isMobilier() {
      try {
        return this.stateWarrantyWarranties.hasOwnProperty('mobilier')
      } catch {
        return false
      }
    },
    isFrais() {
      return (
        this.stateFlowViewOptions.smart_values.frais.compensation_base !== 0
      )
    },
    getRepDeclaration() {
      return this.stateRepDeclaration
    },
    isRen() {
      return this.getE2EFlow === 'ren'
    },

    isBillma() {
      return this.getE2EFlow === 'billma'
    },
    isGag() {
      return this.getE2EFlow === 'gag'
    },
    isDataRen() {
      return this.stateFlowViewOptions.data_ren
    },
    isSummary() {
      return this.stateWarrantySinisterSummary
    }
  },
  components: {
    maActionsButtons
  },

  methods: {
    formatPhone(literal) {
      return `tel:${literal.replace(/\s+/g, '')}`
    },
    formatBulletLiteral(literal) {
      if (!literal) return ''
      return literal.replace(/,\s*-\s*/, ' - ')
    },
    setRenInfo() {
      if (this.isDataRen) {
        this.renInfo = JSON.parse(
          JSON.stringify(this.stateFlowViewOptions.data_ren)
        )
      }
    },
    sendConfirmEmail() {
      apiGetConfirmEmail({ sinisterId: this.getSinisterId })
        .catch((error) => {
          const context = {
            component: 'closing',
            method: 'sendConfirmEmail',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error sending confirmation email: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getWarrantyId,
            'sendConfirmEmail'
          )
        })
    },

    setSummaryInfo() {
      this.summary = this.stateWarrantySinisterSummary
    },

    trackFlowEnd() {
      const endTrackMessage = `Selfcare - customer journey completed`
      this.trackUserFlowTimeStamp(endTrackMessage, this.getSinisterId)
      this.loading = false
    },
    handleViewClosing(event) {
      const damageClaimClosing = 'claim-closing'
      this.goToView(damageClaimClosing)
    }
  },

  mounted() {
    this.setRenInfo()

    this.setSummaryInfo()
    window.addEventListener('popstate', this.handleViewClosing)

    this.address = this.stateWarrantyAddress
  },
  destroy() {
    window.removeEventListener('popstate', this.handleViewClosing)
  }
}
